import { SetStateAction } from "react";
import { AnswerSetResult } from "../../../store/viewmodels/AnswerSetViewModel";
import { Student } from "../../../store/viewmodels/StudentViewModel";
import { Task } from "../../../store/viewmodels/TaskViewModel";
import { getLogos } from "../../../utils/TaskContentServices";
import { ResultsItemsetList } from "./ResultsItemsetList";

interface ResultsTaskListProps {
    student?: Student,
    setSelectedAnswerset: React.Dispatch<SetStateAction<AnswerSetResult>>
}

export function ResultsTaskList(props: ResultsTaskListProps): JSX.Element {
    const studentsTasks: Task[] = props.student ? props.student.task_access_list : [];
    let taskResults = [];

    for (let i: number = 0; i < studentsTasks.length; i++) {
        let theme = studentsTasks[i].theme;
        let theme_logo = studentsTasks[i].logo?.logo;
        let name = theme === "NONE" ? studentsTasks[i].name.toUpperCase() : theme.toUpperCase();
        let altText = theme === "NONE" ? "logo" : theme;

        let vikkeAddress = "https://vikke.nmi.fi/wp-content/uploads/2021/05/Vikke_symboli_800px-768x614.png";
        let imgElement = theme_logo ? <img className="py-1 my-1 pl-1 ml-1 pr-2 mr-2 w-20 h-auto" src={getLogos(theme_logo)} alt={altText} /> : <img className="py-1 my-1 pl-1 ml-1 pr-2 mr-2 w-20 h-auto" src={vikkeAddress} alt={"Vikke"} />;

        taskResults.push(
            <div key={"taskResult" + studentsTasks[i].id} >
                <div className="flex mt-3">
                    {imgElement}
                    <h2 className="my-auto text-xl font-bold text-gray-500" key={"taskheader" + studentsTasks[i].id}>{name}</h2>
                </div>
                <ResultsItemsetList student={props.student} currentTask={studentsTasks[i]} setSelectedAnswerset={props.setSelectedAnswerset} />
            </div>
        );
    }

    return (
        <div>
            {taskResults}
        </div>
    );
}